// For legacy block support
// import 'slick-carousel';
// import initFeatherlight from 'featherlight'
// initFeatherlight();
import './legacy-blocks';

import './blog';
import './navigation';
import './responsive-spacers';
import './search';
import './fslightbox-3.6.0';
import htmx from 'htmx.org';
import Splide from '@splidejs/splide';

htmx.config.globalViewTransitions = true;

document.addEventListener('DOMContentLoaded', function () {
    // Check session storage on page load
    if (sessionStorage.getItem('notificationClosed')) {
        document.querySelector('.kronos-grid')?.classList.remove('-notified');
        document.querySelector('.site-header')?.classList.remove('-notified');
        document.documentElement.style.setProperty('--notification-height', '0px');
    }

    window.notificationClosed = () => {
        document.querySelector('.kronos-grid').classList.remove('-notified');
        document.querySelector('.site-header').classList.remove('-notified');
        document.documentElement.style.setProperty('--notification-height', '0px');
        sessionStorage.setItem('notificationClosed', 'true');

        // Dispatch event for Alpine.js to handle
        window.dispatchEvent(new CustomEvent('hide-notification'));
    }

    // Add function to handle notification bar height
    const updateNotificationHeight = () => {
        const header = document.querySelector('.site-header');
        if (header.classList.contains('-notified')) {
            const notificationBar = document.querySelector('.notification-bar');
            const height = notificationBar.offsetHeight;
            document.documentElement.style.setProperty('--notification-height', `${height}px`);
        } else {
            document.documentElement.style.setProperty('--notification-height', '0px');
        }
    }

    // Run on page load with a small delay
    setTimeout(updateNotificationHeight, 100);

    // Run on window resize to handle dynamic content changes
    window.addEventListener('resize', updateNotificationHeight);
});